import {
  BABY_ELEPHANT,
  BABY_ELEPHANT_15,
  BABY_ELEPHANT_30,
  BABY_ELEPHANT_DARK,
  BABY_ELEPHANT_DARKER,
  ERROR_DARK,
  ERROR_DARK_15,
  ERROR_LIGHT,
  ERROR_LIGHT_15,
  GREY_10,
  GREY_10_70,
  GREY_20,
  GREY_30,
  GREY_40,
  GREY_40_10,
  GREY_40_20,
  GREY_40_50,
  GREY_40_75,
  GREY_50,
  GREY_60,
  GREY_70,
  GREY_80,
  GREY_80_75,
  GREY_90,
  PENDING_DARK,
  PENDING_DARK_15,
  PENDING_LIGHT,
  PENDING_LIGHT_15,
  PINK_OR_PURPLE,
  PINK_OR_PURPLE_10,
  PINK_OR_PURPLE_50,
  PINKLING,
  PINKLING_10,
  PINKLING_50,
  SUCCESS_DARK,
  SUCCESS_DARK_15,
  SUCCESS_LIGHT,
  SUCCESS_LIGHT_15,
  WARNING_DARK,
  WARNING_DARK_15,
  WARNING_LIGHT,
  WARNING_LIGHT_15,
} from './colors';

export const lightTheme = {
  colors: {
    background_1: GREY_20,
    background_2: GREY_10,
    background_3: GREY_30,
    button: {
      primary: {
        default: {
          text: GREY_10,
          fill: GREY_90,
        },
        hover: {
          text: GREY_10,
          fill: GREY_70,
        },
        pressed: {
          text: GREY_10,
          fill: GREY_60,
        },
        disabled: {
          text: GREY_40_75,
          fill: GREY_30,
        },
      },
      secondary: {
        default: {
          text: GREY_90,
          fill: GREY_10,
          border: GREY_40_10,
        },
        hover: {
          text: GREY_90,
          fill: GREY_20,
          border: GREY_40_20,
        },
        pressed: {
          text: GREY_10,
          fill: GREY_30,
          border: GREY_30,
        },
        disabled: {
          text: GREY_40_75,
          fill: GREY_10,
          border: GREY_20,
        },
      },
      ghost: {
        default: {
          text: GREY_90,
        },
        hover: {
          text: GREY_90,
        },
        pressed: {
          text: GREY_90,
        },
        disabled: {
          text: GREY_40_75,
        },
      },
      link: {
        default: {
          text: PINK_OR_PURPLE,
        },
        hover: {
          text: PINK_OR_PURPLE,
        },
        pressed: {
          text: PINK_OR_PURPLE,
        },
        disabled: {
          text: PINK_OR_PURPLE_50,
        },
      },
    },
    buttonFilter: {
      overlay: PINK_OR_PURPLE_10,
      default: {
        backgroundColor: GREY_10,
        border: GREY_30,
      },
      active: {
        backgroundColor: GREY_10,
        border: PINK_OR_PURPLE,
      },
      hover: {
        backgroundColor: GREY_30,
        border: GREY_30,
      },
    },
    checkbox: {
      iconColor: GREY_90,
      default: {
        backgroundColor: GREY_10,
        border: GREY_30,
      },
      active: {
        backgroundColor: GREY_10,
        border: GREY_30,
      },
      disabled: {
        backgroundColor: GREY_20,
        border: GREY_40_10,
      },
    },
    radio: {
      iconColor: GREY_90,
      default: {
        backgroundColor: GREY_10,
        border: GREY_30,
      },
      active: {
        backgroundColor: GREY_10,
        border: GREY_30,
      },
      disabled: {
        backgroundColor: GREY_20,
        border: GREY_40_10,
      },
    },
    input: {
      default: {
        placeholderText: GREY_40,
        text: GREY_40,
        helperText: GREY_40,
        helperTextFill: GREY_40,
        border: GREY_30,
        fillFloatingLabel: GREY_10,
      },
      filled: {
        text: GREY_90,
        helperText: GREY_40,
        border: GREY_40,
      },
      active: {
        border: GREY_90,
        helperText: GREY_40,
        text: GREY_90,
      },
      error: {
        text: GREY_90,
        helperText: ERROR_LIGHT,
        border: GREY_90,
      },
      success: {
        helperText: SUCCESS_LIGHT,
      },
      disabled: {
        text: GREY_40_75,
        helperText: GREY_40_75,
        fill: GREY_30,
        border: GREY_30,
      },
    },
    loader: {
      color: 'rgba(255, 255, 255, 0.90)',
    },
    icon: {
      fill: GREY_20,
      color: GREY_50,
      nakedColor: GREY_90,
      brandColor: PINK_OR_PURPLE,
      attentionColor: WARNING_LIGHT,
      errorColor: ERROR_LIGHT,
      successColor: SUCCESS_LIGHT,
      pendingColor: PENDING_LIGHT,
    },
    text: {
      inverse: GREY_10,
      primary: GREY_90,
      secondary: GREY_80_75,
      secondary50: GREY_40_50,
    },
    navigationButton: {
      fill: GREY_30,
      color: GREY_50,
      border: GREY_40_50,
    },
    stripeCardForm: {
      backgroundColor: GREY_10,
      borderWidth: 1,
      borderColor: GREY_30,
      borderRadius: 4,
      textColor: GREY_90,
      placeholderColor: GREY_40,
      cursorColor: GREY_90,
      textErrorColor: ERROR_LIGHT,
    },
    stripeCardElement: {},
    card: {
      default: {
        backgroundColor: GREY_10,
        borderColor: GREY_30,
      },
      active: {
        backgroundColor: GREY_10,
        borderColor: PINK_OR_PURPLE,
      },
      hover: {
        backgroundColor: GREY_20,
        borderColor: GREY_30,
      },
      disabled: {
        backgroundColor: GREY_20,
        borderColor: GREY_30,
      },
    },
    dialog: {
      backgroundColor: GREY_10,
      borderColor: GREY_30,
    },
    progressBar: {
      active: {
        backgroundColor: GREY_90,
        borderColor: GREY_90,
      },
      inactive: {
        backgroundColor: GREY_30,
        borderColor: GREY_30,
      },
      text: GREY_10,
    },
    dropdown: {
      borderColor: GREY_30,
    },
    carCard: {
      backgroundColor: GREY_20,
      border: GREY_30,
      borderSecondary: GREY_30,
    },
    chip: {
      backgroundColor: GREY_40_10,
      backgroundNeutralColor: GREY_40_10,
      pending: {
        backgroundColor: PENDING_LIGHT_15,
        border: PENDING_LIGHT_15,
        color: PENDING_LIGHT,
      },
      success: {
        backgroundColor: SUCCESS_LIGHT_15,
        border: SUCCESS_LIGHT_15,
        color: SUCCESS_LIGHT,
      },
      error: {
        backgroundColor: ERROR_LIGHT_15,
        border: ERROR_LIGHT_15,
        color: ERROR_LIGHT,
      },
      warning: {
        backgroundColor: WARNING_LIGHT_15,
        border: WARNING_LIGHT_15,
        color: WARNING_LIGHT,
      },
      brand: {
        backgroundColor: PINK_OR_PURPLE_10,
        border: PINK_OR_PURPLE_10,
        color: PINK_OR_PURPLE,
      },
    },
    carMarker: {
      default: {
        backgroundColor: GREY_10,
        border: GREY_30,
      },
      hover: {
        backgroundColor: GREY_20,
        border: PINK_OR_PURPLE,
      },
      active: {
        backgroundColor: GREY_10,
        border: PINK_OR_PURPLE,
      },
    },
    zoomButtons: {
      backgroundColor: GREY_10,
      border: GREY_30,
      divider: GREY_30,
    },
    calendar: {
      default: {
        backgroundColor: GREY_10,
        border: GREY_30,
        borderDivider: GREY_30,
      },
      selected: {
        date: GREY_90,
        time: GREY_20,
        range: GREY_30,
        fillTime: GREY_90,
        borderTime: GREY_30,
      },
    },
    paginationDots: {
      filled: BABY_ELEPHANT,
      empty: GREY_40,
    },
    signature: {
      backgroundColor: GREY_30,
      border: GREY_30,
    },
    tripStep: {
      completed: {
        color: SUCCESS_LIGHT,
      },
      next: {
        color: PENDING_LIGHT,
      },
      upcoming: {
        color: GREY_50,
      },
    },
    cardSwitch: {
      default: {
        backgroundColor: GREY_10,
        border: GREY_30,
        icon: {
          backgroundColor: GREY_20,
          color: GREY_50,
          border: GREY_30,
        },
      },
      active: {
        backgroundColor: GREY_80,
        border: GREY_70,
        icon: {
          backgroundColor: GREY_20,
          color: GREY_50,
          border: GREY_30,
        },
      },
    },
    alert: {
      brand: {
        backgroundColor: PINK_OR_PURPLE_10,
        border: PINK_OR_PURPLE_10,
        buttonBackgroundColor: PINK_OR_PURPLE,
      },
      warning: {
        backgroundColor: WARNING_LIGHT_15,
        border: WARNING_LIGHT_15,
        buttonBackgroundColor: WARNING_LIGHT,
      },
      error: {
        backgroundColor: ERROR_LIGHT_15,
        border: ERROR_LIGHT_15,
        buttonBackgroundColor: ERROR_LIGHT,
      },
      success: {
        backgroundColor: SUCCESS_LIGHT_15,
        border: SUCCESS_LIGHT_15,
        buttonBackgroundColor: SUCCESS_LIGHT,
      },
    },
    progressIndicator: {
      inactive: {
        backgroundColor: GREY_40_50,
      },
      active: {
        backgroundColor: GREY_90,
      },
    },
    toggle: {
      default: {
        backgroundColor: GREY_40,
        handle: GREY_10,
        border: GREY_30,
      },
      active: {
        backgroundColor: PINK_OR_PURPLE,
        handle: GREY_10,
        border: PINKLING,
      },
      disabled: {
        backgroundColor: GREY_20,
        handle: GREY_10,
        border: GREY_40_10,
      },
    },
    histogram: {
      default: {
        backgroundColor: GREY_30,
      },
      active: {
        backgroundColor: PINK_OR_PURPLE,
      },
    },
    success: SUCCESS_LIGHT,
    pending: PENDING_LIGHT,
    warning: WARNING_LIGHT,
    error: ERROR_LIGHT,
    success_15: SUCCESS_LIGHT_15,
    pending_15: PENDING_LIGHT_15,
    warning_15: WARNING_LIGHT_15,
    error_15: ERROR_LIGHT_15,
  },
  margins: {
    sm: 2,
    md: 4,
    lg: 8,
    xl: 12,
  },
  paddingOffset: 16,
} as const;

export const darkTheme = {
  colors: {
    background_1: GREY_90,
    background_2: GREY_80,
    background_3: GREY_70,
    button: {
      primary: {
        default: {
          text: GREY_90,
          fill: BABY_ELEPHANT,
        },
        hover: {
          text: GREY_90,
          fill: BABY_ELEPHANT_DARK,
        },
        pressed: {
          text: GREY_90,
          fill: BABY_ELEPHANT_DARKER,
        },
        disabled: {
          text: GREY_40_50,
          fill: GREY_60,
        },
      },
      secondary: {
        default: {
          text: GREY_10,
          fill: GREY_80,
          border: GREY_40_10,
        },
        hover: {
          text: GREY_10,
          fill: GREY_70,
          border: GREY_40_20,
        },
        pressed: {
          text: GREY_10,
          fill: GREY_70,
          border: GREY_30,
        },
        disabled: {
          text: GREY_40_75,
          fill: GREY_80,
          border: GREY_80,
        },
      },
      ghost: {
        default: {
          text: GREY_10,
        },
        hover: {
          text: GREY_10,
        },
        pressed: {
          text: GREY_10,
        },
        disabled: {
          text: GREY_40_50,
        },
      },
      link: {
        default: {
          text: PINKLING,
        },
        hover: {
          text: PINKLING,
        },
        pressed: {
          text: PINKLING,
        },
        disabled: {
          text: PINKLING_50,
        },
      },
    },
    buttonFilter: {
      overlay: PINK_OR_PURPLE_10,
      default: {
        backgroundColor: GREY_80,
        border: GREY_70,
      },
      active: {
        backgroundColor: GREY_80,
        border: PINKLING,
      },
      hover: {
        backgroundColor: GREY_70,
        border: GREY_60,
      },
    },
    checkbox: {
      iconColor: BABY_ELEPHANT,
      default: {
        backgroundColor: GREY_70,
        border: GREY_50,
      },
      active: {
        backgroundColor: BABY_ELEPHANT_15,
        border: BABY_ELEPHANT_30,
      },
      disabled: {
        backgroundColor: GREY_40_10,
        border: GREY_40_10,
      },
    },
    radio: {
      iconColor: BABY_ELEPHANT,
      default: {
        backgroundColor: GREY_70,
        border: GREY_50,
      },
      active: {
        backgroundColor: BABY_ELEPHANT_15,
        border: BABY_ELEPHANT_30,
      },
      disabled: {
        backgroundColor: GREY_40_10,
        border: GREY_40_10,
      },
    },
    input: {
      default: {
        placeholderText: GREY_40,
        text: GREY_10,
        helperText: GREY_40,
        helperTextFill: GREY_40,
        border: GREY_60,
        fillFloatingLabel: GREY_90,
      },
      filled: {
        text: GREY_10,
        helperText: GREY_40,
        border: GREY_40,
      },
      active: {
        border: BABY_ELEPHANT,
        helperText: GREY_40,
        text: GREY_10,
      },
      error: {
        text: GREY_10,
        helperText: ERROR_DARK,
        border: BABY_ELEPHANT,
      },
      success: {
        helperText: SUCCESS_DARK,
      },
      disabled: {
        text: GREY_40_50,
        helperText: GREY_40_50,
        fill: GREY_70,
        border: GREY_70,
      },
    },
    loader: {
      color: 'rgba(0, 0, 0, 0.90)',
    },
    icon: {
      fill: GREY_70,
      color: GREY_40,
      nakedColor: GREY_10,
      brandColor: PINKLING,
      attentionColor: WARNING_DARK,
      errorColor: ERROR_DARK,
      successColor: SUCCESS_DARK,
      pendingColor: PENDING_DARK,
    },
    text: {
      inverse: GREY_90,
      primary: GREY_10,
      secondary: GREY_10_70,
      secondary50: GREY_40_50,
    },
    navigationButton: {
      fill: GREY_70,
      color: GREY_40,
      border: GREY_40_50,
    },
    stripeCardForm: {
      backgroundColor: GREY_80,
      borderWidth: 1,
      borderColor: GREY_60,
      borderRadius: 4,
      textColor: GREY_10,
      placeholderColor: GREY_40,
      cursorColor: GREY_90,
      textErrorColor: ERROR_DARK,
    },
    card: {
      default: {
        backgroundColor: GREY_80,
        borderColor: GREY_70,
      },
      active: {
        backgroundColor: GREY_80,
        borderColor: PINKLING,
      },
      hover: {
        backgroundColor: GREY_70,
        borderColor: GREY_60,
      },
      disabled: {
        backgroundColor: GREY_90,
        borderColor: GREY_70,
      },
    },
    dialog: {
      backgroundColor: GREY_80,
      borderColor: GREY_70,
    },
    progressBar: {
      active: {
        backgroundColor: BABY_ELEPHANT,
        borderColor: BABY_ELEPHANT,
      },
      inactive: {
        backgroundColor: GREY_60,
        borderColor: GREY_60,
      },
      text: GREY_90,
    },
    dropdown: {
      borderColor: GREY_60,
    },
    carCard: {
      backgroundColor: GREY_70,
      border: GREY_60,
      borderSecondary: GREY_70,
    },
    chip: {
      backgroundColor: GREY_70,
      backgroundNeutralColor: GREY_40_10,
      pending: {
        backgroundColor: PENDING_DARK_15,
        border: PENDING_DARK_15,
        color: PENDING_DARK,
      },
      success: {
        backgroundColor: SUCCESS_DARK_15,
        border: SUCCESS_DARK_15,
        color: SUCCESS_DARK,
      },
      error: {
        backgroundColor: ERROR_DARK_15,
        border: ERROR_DARK_15,
        color: ERROR_DARK,
      },
      warning: {
        backgroundColor: WARNING_DARK_15,
        border: WARNING_DARK_15,
        color: WARNING_DARK,
      },
      brand: {
        backgroundColor: PINKLING_10,
        border: PINKLING_10,
        color: PINKLING,
      },
    },
    carMarker: {
      default: {
        backgroundColor: GREY_80,
        border: GREY_60,
      },
      hover: {
        backgroundColor: GREY_80,
        border: PINKLING,
      },
      active: {
        backgroundColor: GREY_80,
        border: PINKLING,
      },
    },
    zoomButtons: {
      backgroundColor: GREY_70,
      border: GREY_60,
      divider: GREY_60,
    },
    calendar: {
      default: {
        backgroundColor: GREY_80,
        border: GREY_70,
        borderDivider: GREY_60,
      },
      selected: {
        date: BABY_ELEPHANT,
        time: GREY_70,
        range: GREY_70,
        fillTime: BABY_ELEPHANT,
        borderTime: GREY_60,
      },
    },
    paginationDots: {
      filled: BABY_ELEPHANT,
      empty: GREY_40,
    },
    signature: {
      backgroundColor: GREY_70,
      border: GREY_60,
    },
    tripStep: {
      completed: {
        color: SUCCESS_DARK,
      },
      next: {
        color: PENDING_DARK,
      },
      upcoming: {
        color: GREY_40,
      },
    },
    cardSwitch: {
      default: {
        backgroundColor: GREY_80,
        border: GREY_70,
        icon: {
          backgroundColor: GREY_70,
          color: GREY_40,
          border: GREY_70,
        },
      },
      active: {
        backgroundColor: GREY_10,
        border: GREY_30,
        icon: {
          backgroundColor: GREY_10,
          color: GREY_40,
          border: GREY_30,
        },
      },
    },
    alert: {
      brand: {
        backgroundColor: PINKLING_10,
        border: PINKLING_10,
        buttonBackgroundColor: PINKLING,
      },
      warning: {
        backgroundColor: WARNING_DARK_15,
        border: WARNING_DARK_15,
        buttonBackgroundColor: WARNING_DARK,
      },
      error: {
        backgroundColor: ERROR_DARK_15,
        border: ERROR_DARK_15,
        buttonBackgroundColor: ERROR_DARK,
      },
      success: {
        backgroundColor: SUCCESS_DARK_15,
        border: SUCCESS_DARK_15,
        buttonBackgroundColor: SUCCESS_DARK,
      },
    },
    progressIndicator: {
      inactive: {
        backgroundColor: GREY_60,
      },
      active: {
        backgroundColor: BABY_ELEPHANT,
      },
    },
    toggle: {
      default: {
        backgroundColor: GREY_70,
        handle: GREY_10,
        border: GREY_50,
      },
      active: {
        backgroundColor: BABY_ELEPHANT_30,
        handle: GREY_10,
        border: BABY_ELEPHANT_30,
      },
      disabled: {
        backgroundColor: GREY_40_10,
        handle: GREY_10,
        border: GREY_40_10,
      },
    },
    histogram: {
      default: {
        backgroundColor: GREY_60,
      },
      active: {
        backgroundColor: PINKLING,
      },
    },
    success: SUCCESS_DARK,
    pending: PENDING_DARK,
    warning: WARNING_DARK,
    error: ERROR_DARK,
    success_15: SUCCESS_DARK_15,
    pending_15: PENDING_DARK_15,
    warning_15: WARNING_DARK_15,
    error_15: ERROR_DARK_15,
  },
  margins: {
    sm: 2,
    md: 4,
    lg: 8,
    xl: 12,
  },
  paddingOffset: 16,
} as const;
